import { render, staticRenderFns } from "./MonoMetaIcon.vue?vue&type=template&id=51cdb46e&scoped=true"
import script from "./MonoMetaIcon.vue?vue&type=script&lang=js"
export * from "./MonoMetaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cdb46e",
  null
  
)

export default component.exports